import { mutatorAction } from "satcheljs";
import { shiftEditorViewState } from "..";

export default mutatorAction("updateTagsOpenShift", function updateTagsOpenShift(tagIds: string[]) {
    if (shiftEditorViewState().openShift) {
        shiftEditorViewState().openShift.tagIds = tagIds;
    }
});